import React from "react";

import { Row, Col } from "components/layout";
import { LoadingText } from "components/Text";

import TimeStat from "../TimeStat";
import UnloadingMethod from "../UnloadingMethod";
import ProcessProgress from "../ProcessProgress";
import { NextShiftMessage } from "../NextShift";

import forkliftImg from "../../assets/images/forklift.svg";

const UnloadWithForkliftView = ({
  isCalculatingTargetTime,
  progress,
  progressColor,
  isBreakTime,
  targetTime,
  currentTime,
  totalTime,
}) => {
  return (
    <Row align="middle" style={{ height: "100%" }}>
      <Col offset={1} span={9}>
        <ProcessProgress
          label="Progress"
          progress={progress}
          progressColor={progressColor}
          style={{
            width: "34vw",
            height: "34vw",
          }}
          textStyles={{
            fontSize: "8vw",
          }}
          labelStyles={{
            fontSize: "4vw",
          }}
        />
      </Col>
      {isBreakTime ? (
        <Col
          offset={1}
          span={12}
          style={{
            height: "80%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
          }}
        >
          <Row>
            <NextShiftMessage>
              <span>Waiting for</span> <br />
              <span>work to</span>
              <br />
              <span>resume</span>
            </NextShiftMessage>
          </Row>
          <Row style={{ paddingTop: "8vh" }}>
            <TimeStat
              label="Total time"
              value={totalTime}
              styles={{
                value: {
                  color: "white",
                },
              }}
            />
          </Row>
        </Col>
      ) : (
        <Col offset={1} span={13}>
          <Row>
            <UnloadingMethod
              method="forklift"
              imgSrc={forkliftImg}
              styles={{
                wrapper: {
                  flexDirection: "row",
                  justifyContent: "flex-start",
                  alignItems: "center",
                },
                text: { fontSize: "2.6vw", maxWidth: "20ch" },
                img: { height: "6vh", marginRight: "1vw", marginBottom: "0" },
              }}
            />
          </Row>
          <Row style={{ paddingTop: "4vh" }}>
            <TimeStat
              label="Target Time"
              value={
                !isCalculatingTargetTime ? (
                  targetTime
                ) : (
                  <LoadingText style={{ color: "#FFFFFF" }}>
                    Calculating
                  </LoadingText>
                )
              }
              styles={{
                value: {
                  fontSize: !isCalculatingTargetTime ? "8vw" : "5vw",
                  lineHeight: !isCalculatingTargetTime ? 1 : "1.2",
                  paddingRight: !isCalculatingTargetTime ? 0 : "3ch",
                },
              }}
            />
          </Row>
          <Row style={{ paddingTop: "4vh" }}>
            <TimeStat label="Your Time" value={currentTime} />
          </Row>
        </Col>
      )}
    </Row>
  );
};

export default UnloadWithForkliftView;
